import * as React from 'react';
export const digitalDollarSvg = React.forwardRef(function digitalDollarSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.5 8A6.5 6.5 0 0 1 8 14.5 6.5 6.5 0 0 1 1.5 8 6.5 6.5 0 0 1 8 1.5c3.6 0 6.5 2.908 6.5 6.5ZM16 8a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8c4.43 0 8 3.581 8 8ZM8.75 3.5a.75.75 0 0 0-1.5 0v.568h-.292a2.15 2.15 0 0 0-1.584.71 2.417 2.417 0 0 0-.624 1.631c0 .6.218 1.189.624 1.632a2.15 2.15 0 0 0 1.584.709h2.084a.65.65 0 0 1 .478.223c.14.153.23.375.23.618s-.09.464-.23.618a.65.65 0 0 1-.478.223H5.5a.75.75 0 0 0 0 1.5h1.75v.568a.75.75 0 0 0 1.5 0v-.568h.292a2.15 2.15 0 0 0 1.584-.71c.406-.442.624-1.03.624-1.631 0-.6-.218-1.189-.624-1.632a2.15 2.15 0 0 0-1.584-.709H6.958a.65.65 0 0 1-.478-.223.918.918 0 0 1-.23-.618c0-.243.09-.464.23-.618a.65.65 0 0 1 .478-.223h3.125a.75.75 0 0 0 0-1.5H8.75V3.5Z',
    }),
  );
});
digitalDollarSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var digitalDollar = {
  category: 'icon',
  colorable: true,
  name: 'digitalDollar',
  svg: digitalDollarSvg,
};
